export const TILE = 48;
export const GRID_W = 15;
export const GRID_H = 13;
export const CANVAS_W = TILE * GRID_W;
export const CANVAS_H = TILE * GRID_H;

export type PlayerId = 'p1' | 'p2' | 'boss';
export type HumanPlayerId = 'p1' | 'p2';

export const CONTROLS = {
  p1: { plant: 'Q', remote: 'TAB', up: 'W', down: 'S', left: 'A', right: 'D' },
  p2: { plant: 'ENTER', remote: 'SHIFT', up: 'UP', down: 'DOWN', left: 'LEFT', right: 'RIGHT' },
} as const;

export interface PlayerStats {
  bombCount: number;
  bombRange: number;
  speedLevel: number;
  hasKick: boolean;
  hasPierce: boolean;
  hasShield: boolean;
  hasRemote: boolean;
}

export const DEFAULT_STATS: PlayerStats = {
  bombCount: 1,
  bombRange: 1,
  speedLevel: 0,
  hasKick: false,
  hasPierce: false,
  hasShield: false,
  hasRemote: false,
};

export const PLAYER_BASE_SPEED = 210;
export const SPEED_PER_LEVEL = 30;

export interface LevelMap {
  world: number;
  stage: number;
  layout: string[];
  enemyCount: number;
  timeLimit: number;
}
